import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { IAppState } from "../store/states/app";
import { combineLatest, Observable } from "rxjs";
import {
  selectIsAuthenticated,
  authenticationErrors,
  selectIsAuthenticating,
  selectAuthenticatedUser,
} from "../../app/store/selectors";
import { ROUTES_CONFIG } from "../config";

@Injectable({ providedIn: "root" })
export default class AuthGuard implements CanActivate {
  /**
   * @param router
   * @param _store
   */
  constructor(
    private router: Router,
    private _store: Store<IAppState>,
  ) {
    //
  }

  /**
   * @param route
   * @param state
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    return new Observable<boolean>((observer) => {
      combineLatest(
        this._store.select(selectIsAuthenticated),
        this._store.select(selectIsAuthenticating),
        this._store.select(selectAuthenticatedUser),
      ).subscribe(([authenticated, authenticating, user]) => {
        authenticated
          ? observer.next(true)
          : (this.router.navigate([
              ROUTES_CONFIG.LOGIN_ROUTE.PARENT +
                ROUTES_CONFIG.LOGIN_ROUTE.ROUTE,
            ]),
            observer.next(false));
      });
    });
  }
}
